import React, {useEffect, useState} from "react";
import EmailImage from "../assets/images/Email.png";
import DownloadImage from "../assets/images/download 1.png";
import MailImage from "../assets/images/mail.png";
import {
    getDownloadPdf,
    getEmailConfiguration,
    getOffersList,
} from "../services/TractorService";
import {useTranslation} from "react-i18next";
import {useConfigurator} from "../context/ConfiguratorContext";
import {useLocation, useNavigate} from "react-router-dom";
import Axios from "axios";
import {toast} from "react-toastify";
import FileDownload from "js-file-download";
import Utils from "../utils";
import {useParams} from "react-router-dom";

const ThankYouPage = () => {
    const {t} = useTranslation();
    const state = useLocation();
    const navigate = useNavigate();
    const [pdfLoader, setPdfLoader] = useState(false);

    const [offersList, setOffersList] = useState([]);

    const {
        setSelectedTractor,
        setSelectedTires,
        setSelectedUpgrades,
        setSelectedAttachments,
        setSelectedEquipment,
        setSelectedAccessories,
    } = useConfigurator();
    const {dealerUuid} = useParams();

    const handleNewTractor = () => {
        setSelectedTractor(null);
        setSelectedTires([]);
        setSelectedUpgrades([]);
        setSelectedAttachments([]);
        setSelectedEquipment([]);
        setSelectedAccessories([]);
        if (dealerUuid) {
            navigate(`/dealer/${dealerUuid}`);
        } else {
            navigate("/configuration");
        }
    };

    useEffect(() => {
        getOffersList()
            .then((response) => {
                setOffersList(response.data.data);
            })
            .catch((err) => {
            });
    }, []);

    const handleDownLoadPdf = async () => {
        setPdfLoader(true);
        let data = {
            uuid: state.state,
        };
        let result = {};
        await getDownloadPdf(data)
            .then((response) => {
                result = response.data.data;
            })
            .catch((err) => {
                setPdfLoader(false);
                toast.error(Utils.getErrorMessage(err));
            });

        if (result?.url) {
            await Axios({
                url: result?.url,
                method: "GET",
                responseType: "blob",
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    Accept: "*/*",
                },
            }).then((res) => {
                FileDownload(res.data, result?.filename);
                setPdfLoader(false);
            }).catch((err) => {
                setPdfLoader(false);
                toast.error("Oops...something went wrong. File not found.");
            });
        } else {
            setPdfLoader(false);
        }
    };

    const handleEmailConfig = async () => {
        let data = {
            uuid: state.state,
        };
        getEmailConfiguration(data)
            .then((response) => {
                toast.success(response.data.message);
            })
            .catch((err) => {
                toast.error(Utils.getErrorMessage(err));
            });
    };

    return (
        <div>
            <div className="container">
                <div className="row d-flex justify-content-center mt-5">
                    <div className="col-lg-10">
                        <div className="card">
                            <div className="card-body">
                                <div
                                    className="card-body d-flex justify-content-center align-items-center"
                                    style={{flexDirection: "column"}}
                                >
                                    <img src={EmailImage} className="img-fluid" alt="thanks"/>
                                    <h1
                                        className="fw-bold mt-5 mb-3 text-danger">
                                        {t("thankYou")}
                                    </h1>
                                    <div>
                                        {t("thank_you_msg_1")}
                                    </div>
                                    <div className={`mb-4`}>
                                        {t("thank_you_msg_2")}
                                    </div>
                                    <div className="row justify-content-center">
                                        <div className="col-md-4">
                                            {pdfLoader ? (
                                                <span className="badge tractor-label-badge-final cur-pointer">
                                                    <span
                                                        className="d-flex justify-content-center cursor-pointer">loading...</span>
                                                </span>
                                            ) : (
                                                <span className="badge tractor-label-badge-final cur-pointer"
                                                      onClick={handleDownLoadPdf}>
                                                    <span className="d-flex justify-content-center cursor-pointer"
                                                          style={{marginTop: "5px",}}>
                                                        <img src={DownloadImage} alt="download"
                                                             style={{width: "20px", height: "20px"}}
                                                             className="me-2 cursor-pointer"/>
                                                        <span className="me-2">{t("downloadPDFSummary")}</span>
                                                    </span>
                                                </span>
                                            )}
                                        </div>
                                        <div className="col-md-4">
                      <span className="badge tractor-label-badge-final cur-pointer" onClick={handleEmailConfig}>
                        <span
                            className="d-flex justify-content-center"
                            style={{
                                marginTop: "5px",
                            }}
                        >
                          <img
                              src={MailImage}
                              alt="mail"
                              style={{
                                  width: "20px",
                                  height: "20px",
                              }}
                              className="me-2"
                          />
                          <span className="me-2">
                            {t("emailConfiguration")}
                          </span>
                        </span>
                      </span>{" "}
                                        </div>
                                        {" "}
                                        <div className="d-flex justify-content-center">
                                            <button
                                                className="btn btn-danger mt-3 tractor-custom-button"
                                                onClick={handleNewTractor}
                                            >
                        <span className="tractor-custom-text">
                          {t("configureAnotherTractor")}
                        </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {offersList.length > 0 && (
                <div className="container">
                    <div className="row mt-5 d-flex justify-content-center">
                        <div className="col-lg-10">
                            <div className="row">
                                <div className="col-md-12">
                                    <h3 className={`text-danger fw-bold text-center mb-4`}>{t(`special_offers`)}</h3>
                                </div>
                                {offersList?.map((item, index) => {
                                    return (
                                        <div
                                            className="col-xl-4 d-flex equal-height"
                                            key={index}
                                        >
                                            <div className="card custom-card custom-card-choose card-tractor-details">
                                                <div className="position-relative">
                                                    <img
                                                        src={item.image}
                                                        className="card-img-top tires-img"
                                                        alt={item.name}
                                                    />
                                                </div>
                                                <div className="card-body d-flex flex-column">
                                                    <h6 className="card-title-custom">
                                                        {item.name}
                                                    </h6>
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: item.detail,
                                                        }}
                                                        className="card-text card-description-details"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ThankYouPage;
